export const ApplePayId = -1
export const GooglePayId = -2
